import cateringOrderBackend from '@/api/base/cateringOrderBackend'

export default {
  index() {
    const { api, paths } = cateringOrderBackend()
    return api.get(paths.salesRepresentatives())
  }
}
